import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "DELETE_ORDER_FOB_" }
);

export interface DeleteOrderFOBState extends IState {}

const INITIAL_STATE: DeleteOrderFOBState = {
  loading: false,
  error: null,
};

const request = (state:  DeleteOrderFOBState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state:  DeleteOrderFOBState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state:  DeleteOrderFOBState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const deleteOrderFOB = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const DeleteOrderFOBTypes = Types;
export const DeleteOrderFOBActions = Creators;
